export const INDUSTRY_CHOICES = [
  { key: "hash-accessories", label: "Accessories" },
  { key: "hash-artist", label: "Artist" },
  { key: "hash-clothing", label: "Clothing" },
  { key: "hash-coffee", label: "Coffee" },
  { key: "hash-creativebuzz", label: "Creative Buzz" },
  { key: "hash-creativecommunity", label: "Creative Community" },
  { key: "hash-creatives", label: "Creatives" },
  { key: "hash-designer", label: "Designer" },
  { key: "hash-diycraft", label: "DIY Craft" },
  { key: "hash-eco-friendly", label: "Eco-friendly" },
  { key: "hash-embroidery", label: "Embroidery" },
  { key: "hash-etsy", label: "Etsy" },
  { key: "hash-events", label: "Events" },
  { key: "hash-fashion", label: "Fashion" },
  { key: "hash-florist", label: "Florist" },
  { key: "hash-food", label: "Food" },
  { key: "hash-foodpackaging", label: "Food Packaging" },
  { key: "hash-healthandbeauty-2", label: "Health and Beauty" },
  { key: "hash-homeandgift", label: "Home and Gift" },
  { key: "hash-homeware", label: "Homeware" },
  { key: "hash-hospitality", label: "Hospitality" },
  { key: "hash-illustrator", label: "Illustrator" },
  { key: "hash-kidswear", label: "Kids Wear" },
  { key: "hash-letteringandcalligraphy", label: "Lettering and Calligraphy" },
  { key: "hash-lingerie", label: "Lingerie" },
  { key: "hash-menswear", label: "Menswear" },
  { key: "hash-partner", label: "Partner" },
  { key: "hash-poshmark", label: "Poshmark" },
  { key: "hash-pottery", label: "Pottery" },
  { key: "hash-shapingtomorrow", label: "Shaping Tomorrow" },
  { key: "hash-stationery", label: "Stationery" },
  { key: "hash-swimwear", label: "Swimwear" },
];

export const COUNTRY_LIST = [
  "Atlanta",
  "#AUSTRALIA",
  "Bangkok",
  "Brisbane",
  "Bristol",
  "#CANADA",
  "Dubai",
  "England",
  "#FINLAND",
  "#GERMANY",
  "#HONG KONG",
  "#ITALY",
  "#KOREA",
  "Los Angeles",
  "New York",
  "#NEW ZEALAND",
  "Seattle",
  "#SINGAPORE",
  "#SPAIN",
  "#THAILAND",
  "#UNITED ARAB EMIRATES",
  "#UNITED KINGDOM",
  "#UNITED STATES OF AMERICA",
  "USA",
  "California",
  "San Francisco",
  "New Jersey",
  "Melbourne",
  "#NORWAY",
  "Manchester",
  "#SWITZERLAND",
  "London",
  "#FRANCE",
  "Wales",
  "Sydney",
  "Brooklyn",
  "#PORTUGAL",
  "Vienna",
  "Austria",
  "Manila",
  "#PHILIPPINES",
  "BIPOC",
  "Portland",
  "Oregon",
  "Gerogia",
  "#JAPAN",
  "Asia",
  "Europe",
  "Vancouver",
  "North Carolina",
  "#Pottery",
  "Utah",
  "Pacific Islander",
  "#Malaysia",
  "Chicago",
  "Macrame",
  "Puerto Rico",
  "#Ireland",
  "Denmark",
  "#Netherlands",
  "#COLOMBIA",
  "Barcelona",
  "Iowa",
  "Auckland",
  "Argentina",
  "Dominican Republic",
  "Ohio",
  "Gold Coast",
  "New South Wales",
  "Poland",
  "Israel",
  "British Columbia",
  "Toronto",
  "miami",
  "Queensland",
  "Dublin",
  "Alberta",
  "Ontario",
  "Malta",
  "Victoria",
  "#CHILE",
  "Washington DC",
  "Cyprus",
  "Vermont",
  "northwales",
  "#Poshmark",
  "Florida",
  "Paris",
  "Wanaka",
  "San Diego",
  "Bogotá",
  "Wellington",
  "Oklahoma",
  "#INDONESIA",
  "Tokyo",
  "Berlin",
  "Bali",
  "#EGYPT",
];

export const ECO_COUNTRY_LIST = [
  "Alberta",
  "Argentina",
  "Auckland",
  "Austria",
  "Australia",
  "Barcelona",
  "Brazil",
  "Brisbane",
  "British Columbia",
  "California",
  "Canada",
  "Cyprus",
  "Dominican Republic",
  "England",
  "Florida",
  "Illinois",
  "Iowa",
  "Israel",
  "Japan",
  "Lithuania",
  "London",
  "Malta",
  "Melbourne",
  "Minnesota",
  "Missouri",
  "Montreal",
  "New Jersey",
  "New South Wales",
  "New York",
  "New Zealand",
  "North Carolina",
  "Ohio",
  "Ontario",
  "Oregon",
  "Pennsylvania",
  "Portland",
  "Puerto Rico",
  "Seattle",
  "Spain",
  "Tennessee",
  "Texas",
  "Tokyo",
  "Toronto",
  "Torquay",
  "USA",
  "#UNITED KINGDOM",
  "Utah",
  "Vancouver",
  "Venezuela",
  "Vermont",
  "Vienna ",
  "Wales",
  "Washington DC"
]